import axios from "axios";
import { ApiUrl } from "./ApiUrl";

export const GetListTimeExcluded = async (
  vehicleTypeId: number,
  type: string,
  date: Date
) => {
  try {
    const res = await axios.request({
      method: "GET",
      url: `${ApiUrl}/serviceExcludeTime`,
      params: {
        filter: { VehicleTypeId: vehicleTypeId, Type: type },
      },
    });

    let excludedTimes: string[] = [];
    res.data.forEach((item: any) => {
      let dateExclude = new Date(item.dateTimeExclude);
      if (isSameDate(dateExclude, date)) {
        excludedTimes.push(getTimeFromDate(dateExclude));
      }
    });

    let isDateExclude: boolean = res.data.some((item: any) => {
      let dateExclude = new Date(item.dateTimeExclude);
      return dateExclude.getTime() === date.getTime();
    });

    return { isDateExclude, excludedTimes };
  } catch (error) {
    return null;
  }
};

const isSameDate = (date1: Date, date2: Date) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

const getTimeFromDate = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};
